<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PjtZGH/tc-custom/9781423647867.jpg?1718072633850" alt="This image is the cover for the book Small Bites"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Small Bites
      </h1>
      <p class="bookDescription body article font2">
        <b>Big flavors come in small bites with over 60 recipes to enliven events large and small.</b><br/>  <br/> With <i>Small Bites,</i> novice and experienced hosts can prepare easy appetizers that will impress and delight any crowd. Choose from more than sixty savory recipes for finger foods, skewers and picks, and sandwiches and sliders—because whether you’re hosting a sophisticated soiree or a game-day gathering, nibbles are a necessity.<br/>  <br/> Recipes include:<br/> •    Cheesy Tostaditas<br/> •    Artichoke Sausage Pizzas<br/> •    Steak Oscar Tartlets<br/> •    Curried Coconut Chicken Bites<br/> •    Sesame-Ginger Teriyaki Meatballs<br/> •    Kobe Beef Sliders with Secret Sauce<br/> •    Bacon-Wrapped Chevre-Stuffed Apricots and more!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eliza Cross
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e107c1c